import HeroSection from "./components/HeroSection";

export default function Home() {
  return (
    <main className="bg-[#01010a] text-white">
      <HeroSection />
    </main>
  );
}